import { CameraControls } from '@react-three/drei';
import { MeshBasicMaterial, DoubleSide } from 'three';

import { useEffect, useRef } from 'react';
import { useTeeth } from '@patientMenu/hooks/useTeeth.ts';
import * as Three from 'three';

interface TeethViewerProps {
  upperJaw: Three.BufferGeometry;
  lowerJaw: Three.BufferGeometry;
}

export function TeethViewer({ upperJaw, lowerJaw }: TeethViewerProps) {
  const controlsRef = useRef<CameraControls>(null);

  const { upperOpacity, lowerOpacity, showGrid, showAxes, showUpperJaw, showLowerJaw } = useTeeth();

  useEffect(() => {
    const controls = controlsRef.current;
    if (!controls) return;

    const camera = controls.camera as Three.PerspectiveCamera;
    camera.position.set(0, 0, 120);
    camera.fov = 15;
    camera.updateProjectionMatrix();
    controls.setLookAt(0, 0, 200, 0, -6, 0, false);
  }, []);

  return (
    <>
      <CameraControls ref={controlsRef} makeDefault />
      <ambientLight />
      <spotLight position={[0, 10, 0]} angle={0.15} penumbra={1} intensity={50} />

      {showGrid && <gridHelper args={[30, 30]} />}
      {showAxes && <axesHelper scale={5} position={[20, 0, 0]} />}

      <group>
        {showUpperJaw && (
          <mesh
            geometry={upperJaw}
            material={
              new MeshBasicMaterial({
                vertexColors: true,
                transparent: true,
                side: DoubleSide,
                opacity: upperOpacity / 100,
              })
            }
          />
        )}
        {showLowerJaw && (
          <mesh
            geometry={lowerJaw}
            material={
              new MeshBasicMaterial({
                vertexColors: true,
                transparent: true,
                side: DoubleSide,
                opacity: lowerOpacity / 100,
              })
            }
          />
        )}
      </group>
    </>
  );
}
